import { createContext, useContext, useEffect, useState, useCallback } from "react";
import api from "../lib/api";

const FeatureFlagsContext = createContext({
  flags: {},
  isMatriz: false,
  loading: true,
  isEnabled: () => false,
  refresh: () => {},
  dismiss: () => {},
});

export function FeatureFlagsProvider({ children }) {
  const [flags, setFlags] = useState({});
  const [isMatriz, setIsMatriz] = useState(false);
  const [loading, setLoading] = useState(true);

  const load = useCallback(async () => {
    try {
      const { data } = await api.get("/feature-flags");
      setFlags(data.flags || {});
      setIsMatriz(!!data.is_matriz);
    } catch {
      // Usuario no autenticado: sin flags
      setFlags({});
      setIsMatriz(false);
    } finally {
      setLoading(false);
    }
  }, []);

  useEffect(() => { load(); }, [load]);

  const isEnabled = useCallback((flag) => !!flags[flag]?.enabled, [flags]);

  const dismiss = useCallback(async (flag) => {
    await api.post("/feature-flags/dismiss", { flag });
    await load();
  }, [load]);

  return (
    <FeatureFlagsContext.Provider value={{ flags, isMatriz, loading, isEnabled, refresh: load, dismiss }}>
      {children}
    </FeatureFlagsContext.Provider>
  );
}

export function useFeatureFlags() {
  return useContext(FeatureFlagsContext);
}
